import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { CustomerPaymentTypeEnum, BankBrandTypeEnum } from 'graphQL/hatostore/generate/operations'

interface BankAccount {
  brand: BankBrandTypeEnum
  name: string
  number: string
}

interface VendorSetting {
  paymentMethods: CustomerPaymentTypeEnum[]
  orderMinimumLineItemTotalSatangs: number
  orderMinimumTotalSatangs: number
  excludingVat: boolean
  bankAccounts: BankAccount[]
  dineInPaymentMethods?: CustomerPaymentTypeEnum[]
}

export interface VendorState {
  setting: VendorSetting
}

const initialState: VendorState = {
  setting: {
    paymentMethods: [],
    orderMinimumLineItemTotalSatangs: 0,
    orderMinimumTotalSatangs: 0,
    excludingVat: false,
    bankAccounts: [],
    dineInPaymentMethods: [],
  },
}

export const VendorSettingSlice = createSlice({
  name: 'vendor',
  initialState,
  reducers: {
    setVendorSetting: (vendor: VendorState, { payload }: PayloadAction<VendorSetting>) => {
      vendor.setting = payload
    },
  },
})

export const { setVendorSetting } = VendorSettingSlice.actions
export const vendorSelector = (state: RootState) => state.vendor
export default VendorSettingSlice.reducer
